/**
 * Unsponsored web signups stay on the plan step until they leave it
 * on purpose, or until a plan covers them. A reload uses the same rule.
 */

function signupPlanStorageKey(clientId) {
  return 'pacarion.signupPlan.' + String(clientId || '');
}

function signupPlanDismissed(storage, clientId) {
  if (!storage || !clientId) return false;
  try {
    return storage.getItem(signupPlanStorageKey(clientId)) === '1';
  } catch (error) {
    return false;
  }
}

function dismissSignupPlan(storage, clientId) {
  if (!storage || !clientId) return;
  try {
    storage.setItem(signupPlanStorageKey(clientId), '1');
  } catch (error) {
    // The in-memory step still closes for this visit.
  }
}

function clientHasSponsor(client) {
  if (!client) return false;
  if (client.agent_id || client.assigned_agent_id) return true;
  const request = client.joinRequest;
  if (request && (request.status === 'pending' || request.status === 'declined')) return true;
  return false;
}

function signupPlanRequired(client, options) {
  const source = options || {};
  if (source.native) return false;
  if (!client || !client.id) return false;
  if (clientHasSponsor(client)) return false;
  if (source.entitled) return false;
  if (source.dismissed || signupPlanDismissed(source.storage, client.id)) return false;
  return true;
}

module.exports = {
  signupPlanStorageKey,
  signupPlanDismissed,
  dismissSignupPlan,
  clientHasSponsor,
  signupPlanRequired,
};
